import React from 'react';
import {Button, Divider, Input, message, Modal, Select, Spin, Table, Tabs, Descriptions} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";
import ReactJson from "react-json-view";

const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

export default class UserList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            showResourcesDialog: false,
            showMessageDialog: false,
            showAddResourceModal: false,
            showConfirmModal: false,
            showDevicesDialog: false,
            confirmLoading: false,
            backfillNodeCredentialsLoading: false,
            bumpSnapshotVersionLoading: false,
            showUpdateModal: false,
            showCreateUserModal: false,
            devices: [],
            devicesLoading: false,
            devicesTabActiveKey: 'current',
            selectedUserId: null,
            deviceBindingLogs: [],
            deviceBindingLogsLoading: false,
            deviceBindingLogTotal: 0,
            deviceBindingLogCurrentPage: 1,
            deviceBindingLogPageSize: 10,
            selectedRow: {},
            userTrafficInfo: {},
            emailStatusList: [],
            query_params: {},
            form_refund_params: {},
            form_recharge_params: {},
            form_resource_params: {},
            form_traffic_params: {}
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    componentDidMount() {
        this.loadListData();
        this.loadPaymentStatusList();
    }

    setStateParams(params, name, value) {
        params[name] = value;
        this.setState(params);
    }

    loadListData(changedParams) {
        if (!changedParams) {
            changedParams = {
                currentPage: 1,
                pageSize: 10
            };
        }
        let params = this.state.query_params;
        params.currentPage = changedParams.currentPage;
        params.pageSize = changedParams.pageSize;

        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/users', params)
            .then(response => {
                console.debug("query-user-list response -> " + JSON.stringify(response));
                this.setState({loading: false});
                if (response.code === 200) {
                    this.setState({
                        dataList: response.rows,
                        total: response.total,
                        currentPage: changedParams.currentPage,
                        pageSize: changedParams.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    loadPaymentStatusList() {
        new WebServerRestClient().GET('/admin/dict/email-status')
            .then(response => {
                console.log("load email-status response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({emailStatusList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Input placeholder="ID"
                           className="search_input_middle"
                           onChange={(event) => this.setStateParams(this.state.query_params, 'id', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Input placeholder="Email"
                           className="search_input_middle"
                           onChange={(event) => this.setStateParams(this.state.query_params, 'email', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Select placeholder="select one"
                            className="search_input"
                            allowClear={true}
                            onChange={(value) => this.setStateParams(this.state.query_params, 'emailStatus', value)}>
                        {this.state.emailStatusList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary"  icon="search" className="search_btn" loading={this.state.doing}
                            onClick={this.loadListData.bind(this)}>
                        Search
                    </Button>
                    <div className="button_group">
                      <Button type="link" icon="file-add" size={"small"}
                              onClick={this.startCreateUser.bind(this)}>Create</Button>
                      <Button type="link" icon="sync" size={"small"}
                              loading={this.state.backfillNodeCredentialsLoading}
                              onClick={this.confirmBackfillNodeCredentials.bind(this)}>Node Credentials</Button>
                      <Button type="link" icon="reload" size={"small"}
                              loading={this.state.bumpSnapshotVersionLoading}
                              onClick={this.confirmBumpSnapshotVersion.bind(this)}>Node Snapshot</Button>
                    </div>
                </div>

                <Table loading={this.state.loading}
                       rowKey={'id'}
                       columns={[
                           {title: 'ID', dataIndex: 'id', align: 'center'},
                           {title: 'Email', dataIndex: 'email', align: 'center'},
                           {title: 'Name', dataIndex: 'uname', align: 'center'},
                           {title: 'Status', dataIndex: 'emailStatusText', align: 'center' },
                           {title: 'Time', dataIndex: 'createdTime', align: 'center'},
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               render: (text, record) => (
                                   <span>
                                       <a onClick={() => this.showUpdateModal(record)}>Modify</a>
                                       <Divider type="vertical"/>
                                       <a onClick={() => this.loadDevices(record.id)}>Devices</a>
                                       <Divider type="vertical"/>
                                       <a onClick={() => this.startAddResource(record.id)}>Add Days</a>
                                       <Divider type="vertical"/>
                                       <a onClick={() => this.startAddTraffic(record.id)}>Add Traffic</a>
                                       <Divider type="vertical"/>
                                       <a onClick={() => this.loadUserResources(record.id)}>Resources</a>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.total,
                           onChange: (currentPage, pageSize) => {
                               this.setState({loading: true});
                               this.loadListData({currentPage, pageSize});
                           },
                           showTotal: ((total) => {
                               return `total of ${total} records`;
                           }),
                           className: "pagination"
                       }}/>

                <Modal
                    title="User Devices"
                    width={1200}
                    footer={null}
                    visible={this.state.showDevicesDialog}
                    onCancel={() => this.setState({showDevicesDialog: false})}>
                    <Tabs activeKey={this.state.devicesTabActiveKey}
                          onChange={this.handleDevicesTabChange.bind(this)}>
                        <TabPane tab="Current Devices" key="current">
                            <Table loading={this.state.devicesLoading}
                                   rowKey={(record) => `${record.userId || this.state.selectedUserId}-${record.deviceId}`}
                                   dataSource={this.state.devices}
                                   columns={this.getCurrentDeviceColumns()}
                                   pagination={false}/>
                        </TabPane>
                        <TabPane tab="History Devices" key="history">
                            <Table loading={this.state.deviceBindingLogsLoading}
                                   rowKey={'id'}
                                   dataSource={this.state.deviceBindingLogs}
                                   columns={this.getDeviceBindingLogColumns()}
                                   pagination={{
                                       current: this.state.deviceBindingLogCurrentPage,
                                       pageSize: this.state.deviceBindingLogPageSize,
                                       total: this.state.deviceBindingLogTotal,
                                       onChange: (currentPage, pageSize) => {
                                           this.loadDeviceBindingLogs(this.state.selectedUserId, {currentPage, pageSize});
                                       },
                                       showTotal: ((total) => {
                                           return `total of ${total} records`;
                                       }),
                                       className: "pagination"
                                   }}/>
                        </TabPane>
                    </Tabs>
                </Modal>

                <Modal
                    title="User Resources"
                    width={800}
                    footer={null}
                    visible={this.state.showResourcesDialog}
                    onCancel={() => this.setState({showResourcesDialog: false})}>
                    <Table loading={this.state.loading}
                           rowKey={'id'}
                           dataSource={this.state.resources}
                           columns={[
                               {title: 'Days', dataIndex: 'availableDays', align: 'center'},
                               {title: 'ExpireTime', dataIndex: 'expireTime', align: 'center'},
                               {title: 'createdTime', dataIndex: 'createdTime', align: 'center'},
                               {title: 'Remarks', dataIndex: 'remarks', align: 'left'}
                           ]}/>
                </Modal>

                <Modal
                    title="Manual Add Resource"
                    visible={this.state.showAddResourceModal}
                    onCancel={() => this.setState({showAddResourceModal: false})}
                    onOk={() => this.manualAddResource()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                        <Input placeholder={'userId'}
                               className="mt_10 width_100"
                               value={this.state.form_resource_params.userId}
                               onChange={(event) => this.setStateParams(this.state.form_resource_params, 'userId', event.target.value)}/>
                        <Input placeholder={'days'}
                               className="mt_10 width_100"
                               type="number"
                               value={this.state.form_resource_params.availableDays}
                               onChange={(event) => this.setStateParams(this.state.form_resource_params, 'availableDays', event.target.value)}/>
                        <Input placeholder={'remarks'}
                               className="mt_10 width_100"
                               value={this.state.form_resource_params.remarks}
                               onChange={(event) => this.setStateParams(this.state.form_resource_params, 'remarks', event.target.value)}/>
                        <Select className="mt_10 width_100"
                                placeholder="select source type"
                                value={this.state.form_resource_params.source}
                                onChange={(value) => this.setStateParams(this.state.form_resource_params, 'source', value)}>
                                <Option key="6">free-extension</Option>
                                <Option key="8">deducted</Option>
                        </Select>
                </Modal>

                <Modal
                    title="Manual Add Traffic"
                    visible={this.state.showAddTrafficModal}
                    onCancel={() => this.setState({showAddTrafficModal: false})}
                    onOk={() => this.manualAddTraffic()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                    <div>
                        <Descriptions size="small" column={2}>
                            <Descriptions.Item label="Quota">{this.state.userTrafficInfo.quota}</Descriptions.Item>
                            <Descriptions.Item label="Balance">{this.state.userTrafficInfo.balance}</Descriptions.Item>
                            <Descriptions.Item label="Download">{this.state.userTrafficInfo.download}</Descriptions.Item>
                            <Descriptions.Item label="Upload">{this.state.userTrafficInfo.upload}</Descriptions.Item>
                            <Descriptions.Item label="Expire Time">
                                {CommonUtils.formatDate(new Date(this.state.userTrafficInfo.expireTime), 'yyyy-MM-dd')}
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                    <Input placeholder={'Traffic (G)'}
                           className="mt_10 width_100"
                           type="number"
                           value={this.state.form_traffic_params.traffic}
                           onChange={(event) => this.setStateParams(this.state.form_traffic_params, 'traffic', event.target.value)}/>
                    <TextArea placeholder={'Remarks'}
                              className="mt_10 width_100"
                              rows={5}
                              defaultValue={this.state.userTrafficInfo.remarks}
                              // value={this.state.form_traffic_params.remarks}
                              onChange={(event) => this.setStateParams(this.state.form_traffic_params, 'remarks', event.target.value)}/>
                </Modal>

                <Modal
                    width={1000}
                    style={{top: 10}}
                    title={this.state.selectedDeviceId}
                    visible={this.state.showServersModal}
                    onOk={() => this.setState({showServersModal: false})}
                    onCancel={() => this.setState({showServersModal: false})}>
                    <Spin spinning={this.state.serversLoading}>
                        <div>
                            <ReactJson src={this.state.selectedValue}
                                       groupArraysAfterLength={1000}
                                       name={false} displayDataTypes={false}  theme="monokai"/>
                        </div>
                    </Spin>
                </Modal>

                <Modal
                    title="Modify Record"
                    destroyOnClose={true}
                    visible={this.state.showUpdateModal}
                    onCancel={() => this.setState({showUpdateModal: false})}
                    onOk={() => this.updateUser()}
                    confirmLoading={this.state.confirmLoading}
                    okText="Save"
                    cancelText="Cancel">
                    <Input name={'email'} placeholder={'email'}
                           defaultValue={this.state.selectedRow.email}
                           onChange={this.handleInputChange.bind(this)}/>
                    <Input name={'uname'} placeholder={'uname'}
                           className="mt_10"
                           defaultValue={this.state.selectedRow.uname}
                           onChange={this.handleInputChange.bind(this)}/>
                </Modal>

                <Modal
                    title="Create User"
                    destroyOnClose={true}
                    visible={this.state.showCreateUserModal}
                    onCancel={() => this.setState({showCreateUserModal: false})}
                    onOk={() => this.createUser()}
                    confirmLoading={this.state.confirmLoading}
                    okText="Save"
                    cancelText="Cancel">
                  <Input name={'email'} placeholder={'Email'}
                         defaultValue={this.state.email}
                         onChange={this.handleInputChange.bind(this)}/>
                  <Input name={'password'} placeholder={'Password'}
                         className="mt_10"
                         defaultValue={this.state.uname}
                         onChange={this.handleInputChange.bind(this)}/>
                </Modal>
            </div>
        )
    }

    getCurrentDeviceColumns() {
        return [
            {
                title: 'DeviceId',
                dataIndex: 'deviceId',
                align: 'left',
                width: 180,
                render: (text) => this.renderWrappedText(text),
            },
            {
                title: 'DeviceName',
                dataIndex: 'deviceName',
                align: 'left',
                width: 120,
                render: (text) => this.renderWrappedText(text),
            },
            {
                title: 'Platform',
                dataIndex: 'platform',
                align: 'center',
                width: 110,
                render: (text) => this.renderNoWrapText(this.renderPlatform(text)),
            },
            {
                title: 'AppVersion',
                key: 'appVersion',
                align: 'left',
                width: 130,
                render: (text, record) => this.renderWrappedText(this.renderVersion(record)),
            },
            {
                title: 'BindTime',
                dataIndex: 'bindTime',
                align: 'left',
                width: 150,
                render: (text) => this.renderTimestamp(text),
            },
            {
                title: 'LastConnectTime',
                dataIndex: 'lastConnectTime',
                align: 'left',
                width: 150,
                render: (text) => this.renderTimestamp(text),
            },
            {
                title: 'UpdatedTime',
                dataIndex: 'updatedTime',
                align: 'left',
                width: 150,
                render: (text) => this.renderTimestamp(text),
            },
            {
                title: 'Connection',
                key: 'connection',
                align: 'left',
                width: 120,
                render: (text, record) => this.renderWrappedText(this.renderConnectionField(record, 'serverIp')),
            },
        ];
    }

    getDeviceBindingLogColumns() {
        return [
            {title: 'DeviceId', dataIndex: 'deviceId', align: 'left'},
            {title: 'DeviceName', dataIndex: 'deviceName', align: 'left'},
            {
                title: 'Platform',
                dataIndex: 'platform',
                align: 'center',
                render: (text) => this.renderPlatform(text),
            },
            {
                title: 'Version',
                key: 'version',
                align: 'left',
                render: (text, record) => this.renderVersion(record),
            },
            {
                title: 'BindTime',
                dataIndex: 'bindTime',
                align: 'left',
                render: (text) => this.renderTimestamp(text),
            },
            {
                title: 'CreatedTime',
                dataIndex: 'createdTime',
                align: 'left',
                render: (text) => this.renderTimestamp(text),
            },
            {
                title: 'UpdatedTime',
                dataIndex: 'updatedTime',
                align: 'left',
                render: (text) => this.renderTimestamp(text),
            },
        ];
    }

    renderVersion(record) {
        const appVersion = record.appVersion || '';
        const buildNumber = record.buildNumber === 0 || record.buildNumber ? record.buildNumber : '';
        if (!appVersion && buildNumber === '') {
            return '';
        }
        if (!appVersion) {
            return buildNumber;
        }
        if (buildNumber === '') {
            return appVersion;
        }
        return `${appVersion}-${buildNumber}`;
    }

    renderPlatform(platform) {
        const platforms = {
            1: 'android',
            2: 'ios',
            3: 'Windows',
            4: 'Mac',
            5: 'Linux',
            8: 'ios_ganan',
            10: 'android_store',
            11: 'android_tv',
            12: 'android_tv_store',
            20: 'ios_store',
            21: 'ios_tv',
            22: 'ios_tv_store',
            30: 'Windows-Store',
            81: 'ios_ganan_tv',
        };
        return platforms[platform] || platform || '';
    }

    renderConnectionField(record, field) {
        if (!record || !record.connection) {
            return '-';
        }
        return record.connection[field] || '-';
    }

    renderWrappedText(value) {
        const text = value === 0 || value ? value : '';
        return <span style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>{text}</span>;
    }

    renderNoWrapText(value) {
        const text = value === 0 || value ? value : '';
        return <span style={{whiteSpace: 'nowrap'}}>{text}</span>;
    }

    renderTimestamp(timestamp) {
        const formatted = this.formatTimestamp(timestamp);
        if (!formatted || formatted.indexOf(' ') < 0) {
            return this.renderWrappedText(formatted);
        }
        const parts = formatted.split(' ');
        return (
            <span style={{whiteSpace: 'normal', wordBreak: 'normal'}}>
                <span style={{whiteSpace: 'nowrap'}}>{parts[0]}</span>
                <br/>
                <span style={{whiteSpace: 'nowrap'}}>&nbsp;{parts.slice(1).join(' ')}</span>
            </span>
        );
    }

    handleDevicesTabChange(activeKey) {
        this.setState({devicesTabActiveKey: activeKey});
        if (activeKey === 'history') {
            this.loadDeviceBindingLogs(this.state.selectedUserId, {
                currentPage: this.state.deviceBindingLogCurrentPage,
                pageSize: this.state.deviceBindingLogPageSize
            });
        }
    }

    loadDevices(userId) {
        this.setState({
            showDevicesDialog: true,
            devicesTabActiveKey: 'current',
            selectedUserId: userId,
            devices: [],
            devicesLoading: true,
            deviceBindingLogs: [],
            deviceBindingLogTotal: 0,
            deviceBindingLogCurrentPage: 1,
            deviceBindingLogPageSize: 10
        });
        new WebServerRestClient().GET('/admin/users/' + userId + '/devices')
            .then(response => {
                CommonUtils.log("load devices response -> " + JSON.stringify(response));
                this.setState({devicesLoading: false});
                if (response.code === 200) {
                    this.setState({devices: response.data || []})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg'] || response['message']);
                }
            }).catch(err => {
            this.setState({devicesLoading: false});
            message.error("Error: " + err.message);
        });
    }

    loadDeviceBindingLogs(userId, changedParams) {
        if (!userId) {
            return;
        }
        if (!changedParams) {
            changedParams = {
                currentPage: this.state.deviceBindingLogCurrentPage,
                pageSize: this.state.deviceBindingLogPageSize
            };
        }
        const params = {
            userId: userId,
            currentPage: changedParams.currentPage,
            pageSize: changedParams.pageSize
        };

        this.setState({deviceBindingLogsLoading: true});
        new WebServerRestClient().GET('/admin/device-binding-logs', params)
            .then(response => {
                CommonUtils.log("device-binding-logs response -> " + JSON.stringify(response));
                this.setState({deviceBindingLogsLoading: false});
                if (response.code === 200) {
                    const data = response.data || {};
                    this.setState({
                        deviceBindingLogs: data.rows || [],
                        deviceBindingLogTotal: data.totalCount || 0,
                        deviceBindingLogCurrentPage: changedParams.currentPage,
                        deviceBindingLogPageSize: data.pageSize || changedParams.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg'] || response['message']);
                }
            }).catch(err => {
            this.setState({deviceBindingLogsLoading: false});
            message.error("Error: " + err.message);
        });
    }

    formatTimestamp(timestamp) {
        if (!timestamp) {
            return '';
        }
        let time = Number(timestamp);
        if (isNaN(time)) {
            return timestamp;
        }
        if (time < 1000000000000) {
            time *= 1000;
        }
        return CommonUtils.formatDate(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    }

    confirmBackfillNodeCredentials() {
        Modal.confirm({
            title: 'Backfill node credentials?',
            content: 'Each call processes up to 500 active users missing node_password or node_uuid.',
            okText: 'Backfill',
            cancelText: 'Cancel',
            onOk: () => this.backfillNodeCredentials()
        });
    }

    confirmBumpSnapshotVersion() {
        Modal.confirm({
            title: 'Bump node user snapshot version?',
            content: 'This updates the user snapshot version distributed to nodes.',
            okText: 'Bump',
            cancelText: 'Cancel',
            onOk: () => this.bumpSnapshotVersion()
        });
    }

    bumpSnapshotVersion() {
        this.setState({bumpSnapshotVersionLoading: true});
        return new WebServerRestClient().POST('/admin/node-traffic/snapshot-version/bump')
            .then(response => {
                this.setState({bumpSnapshotVersionLoading: false});
                if (response.code === 200) {
                    const versionText = response.data ? `: ${response.data}` : '';
                    message.info(`Snapshot version bumped${versionText}`);
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.warn(response['msg'] || response['message']);
                }
            }).catch(err => {
                this.setState({bumpSnapshotVersionLoading: false});
                message.error("Error: " + err.message);
            });
    }

    backfillNodeCredentials() {
        this.setState({backfillNodeCredentialsLoading: true});
        return new WebServerRestClient().POST('/admin/users/node-credentials/backfill')
            .then(response => {
                this.setState({backfillNodeCredentialsLoading: false});
                if (response.code === 200) {
                    this.showBackfillNodeCredentialsResult(response.data || {});
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
                this.setState({backfillNodeCredentialsLoading: false});
                message.error("Error: " + err.message);
            });
    }

    showBackfillNodeCredentialsResult(data) {
        let remainingCount = data.remainingCount || 0;
        let content = (
            <div style={{paddingTop: 30}}>
                <p>Updated this batch: {data.updatedCount || 0} / {data.scannedCount || 0}</p>
                <p>Remaining: {remainingCount}</p>
            </div>
        );

        if (remainingCount > 0) {
            Modal.confirm({
                title: 'Node credentials backfill batch completed',
                content: content,
                okText: 'Continue',
                cancelText: 'Close',
                onOk: () => this.backfillNodeCredentials()
            });
            return;
        }

        Modal.success({
            title: 'Node credentials backfill completed',
            content: content
        });
    }

    loadUserResources(userId) {
        this.setState({showResourcesDialog: true, loading: true});
        new WebServerRestClient().GET('/admin/user/resources/' + userId)
            .then(response => {
                CommonUtils.log("user/resources response -> " + JSON.stringify(response));
                this.setState({loading: false});
                if (response.code === 200) {
                    this.setState({resources: response.data, loading: false})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    startAddResource(userId){
        let form_params = this.state.form_resource_params;
        form_params.userId = userId;

        // reset value
        delete form_params.availableDays;
        delete form_params.remarks;
        delete form_params.source;
        this.setState({showAddResourceModal: true});
    }

    manualAddResource () {
        let form_params = this.state.form_resource_params;
        if(!form_params.userId || form_params.userId.trim().length === 0){
            message.warn('Parameters[userId] is empty!');
            return false;
        }
        if(!form_params.availableDays || form_params.availableDays <= 0){
            message.warn('Parameters[days] must be a positive number!');
            return false;
        }
        if(!form_params.availableDays || form_params.availableDays === 0){
            message.warn('Parameters[source] is empty!');
            return false;
        }

        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/manual-add-resource', form_params)
            .then(response => {
                CommonUtils.log("manual-add-resource response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code == 200) {
                    this.setState({showAddResourceModal: false});
                    message.info('success');
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

    showServersModal(deviceId){
        let dataKey = 'device_servers:' + deviceId;
        this.setState({showServersModal: true, selectedDeviceId: deviceId, serversLoading: true});
        new WebServerRestClient().GET('/admin/redis/values/' + dataKey)
            .then(response => {
                console.log("query cache value response -> " + response.code);
                this.setState({serversLoading: false});
                if (response.code === 200) {
                    this.setState({selectedValue: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                    this.setState({showServersModal: false});
                }
            }).catch(err => {
            message.error("Error: " + err.message);
            this.setState({serversLoading: false});
        });
    };

    showUpdateModal(row){
        this.setState({
                showUpdateModal: true,
                serversLoading: false,
                selectedRow: row,
                email: row.email,
                uname: row.uname
            }
        );
    }

    updateUser () {
        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/modify-user', {
            userId: this.state.selectedRow.id,
            email: this.state.email,
            uname: this.state.uname
        }).then(response => {
            console.log("modify user response -> " + JSON.stringify(response));
            this.setState({confirmLoading: false});
            if (response.code === 200) {
                this.setState({showUpdateModal: false});
                this.loadListData();
            } else {
                message.warn(response['msg']);
            }
        }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

    startCreateUser() {
        this.setState({
              showCreateUserModal: true,
              email: '',
              uname: '',
              password: ''
            }
        );
    }

    createUser() {
        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/create-user', {
          email: this.state.email.trim(),
          password: this.state.password.trim()
        }).then(response => {
          console.log("create-user response -> " + JSON.stringify(response));
          this.setState({confirmLoading: false});
          if (response.code === 200) {
            this.setState({showCreateUserModal: false});
            this.loadListData();
          } else {
            message.warn(response['msg']);
          }
        }).catch(err => {
          this.setState({confirmLoading: false});
          message.error("Error: " + err.message);
        });
    }

    startAddTraffic(userId){
        this.loadUserTrafficDetails(userId)
    }

    manualAddTraffic(){
        let form_params = this.state.form_traffic_params;
        if(!form_params.userId || form_params.userId.trim().length === 0){
            message.warn('Parameters[userId] is empty!');
            return false;
        }
        if(!form_params.traffic || form_params.traffic <= 0){
            message.warn('Parameters[traffic] must be a positive number!');
            return false;
        }
        if(!form_params.remarks || form_params.remarks.trim().length === 0){
            message.warn('Parameters[remarks] is empty!');
            return false;
        }

        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/manual-add-traffic', form_params)
            .then(response => {
                CommonUtils.log("manual-add-traffic response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showAddTrafficModal: false});
                    message.info('success');
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    }

    loadUserTrafficDetails(userId) {
        this.setState({loading: true})
        new WebServerRestClient().GET('/admin/nodes/' + userId)
            .then(response => {
                this.setState({loading: false})
                if (response.code === 200) {
                    this.setState({userTrafficInfo: response.data})
                    let form_params = this.state.form_traffic_params;

                    // reset value
                    delete form_params.traffic;
                    delete form_params.remarks;
                    // put new value
                    form_params.userId = userId;
                    form_params.remarks = response.data.remarks;

                    this.setState({showAddTrafficModal: true})
                } else if (response.code === 401 || response.code === 403) {
                    message.warn("Please Log In!")
                    this.props.history.push('/')
                } else {
                    message.warn(response['msg'])
                }
            }).catch(err => {
            this.setState({loading: false})
            message.error("Error: " + err.message)
        })
    }
}
